/*
 * @Date: 2023-03-21 14:45:51
 * @LastEditors: Leo
 * @LastEditTime: 2023-06-14 16:49:16
 * @FilePath: \3.0-manger\src\js\plugins\product-detail.js
 */
import { productContrast, productBaseInfo, getPackagedInfo, getGoodsInfo } from '@utils/fetch.js';
import HelpToChoose from './snippets/help-to-choose/index.js'
import { scrollToTop, downloadFile, countUp, replaceLineBreak} from '@utils/index.js';

class BlogCardSwiper {
  constructor(el) {
    this.DOM = {
      el: el.el,
      swiperContainer: el.swiperContainer
    };
    this.init();
  }
  init() {
    let that = this
    this.swiper = new Swiper(this.DOM.swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      followFinger: false,
      pagination: {
        el: `${this.DOM.el} .slideshow-pagination`,
        clickable: true,
        bulletClass: 'slideshow-pagination-item',
        bulletActiveClass: 'active pagination-active',
        clickableClass: 'slideshow-pagination-clickable',
        modifierClass: 'slideshow-pagination-',
        renderBullet: function (index, className) {
          var slideIndex = index,
            number = (index <= 8) ? '0' + (slideIndex + 1) : (slideIndex + 1);

          var paginationItem = '<span class="slideshow-pagination-item">';
          paginationItem = (index <= 8) ? paginationItem +
            '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>' :
            paginationItem;
          paginationItem += '</span>';
          return paginationItem;
        }
      },
      on: {
        resize: function () {
          setTimeout(() => {
            that.swiper?.update()
          }, 600);
        },
        slideChange: function() {
          var activeIndex = this.activeIndex;
          this.slides.each(function (slide, index) {
            if (index !== activeIndex) {
              var video = $(slide).find('jky-video')[0];
              if (video && video.pause) {
                video.pause();
              }
            } else {
              var video = $(slide).find('jky-video')[0];
              if (video && video.loadContent) {
                video.loadContent()
              }
            }
          });
        }
      }
    })
  }
}

class ProductContrastInfo {
  constructor(el) {
    this.config = el;
    this.init();
  }
  init() {
    const _this = this;
    let { currentVariant, productVariants, helpToChoose } = _this.config;
    let help = null
    if(document.querySelector(".product-help-choose-wrapper") || document.querySelector('.help-to-choose')) {
      // 智能选购插件，接收 pageType 参数
      // PPS详情页=pps_detail，SP详情页=sp_detail，SP聚合页=sp_gather
      help = new HelpToChoose(helpToChoose);
    }

    $(".variant-input-wrap input:radio[name='id']").change(function() {
      const v = $(this).val();
      let variant = productVariants[v];
      currentVariant = variant;
      
      _this.variantChange(currentVariant, help, helpToChoose);
    });

    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          _this.variantChange(currentVariant, help, helpToChoose);
        }
      })
    }

    _this.getContrastInfo(currentVariant.id);
    _this.getSpecsInfo(currentVariant.id);
    _this.getVariantManual(currentVariant.sku, currentVariant.id);


    // running time
    $('.J-running-time').find('.time-input').change(function() {
      let $timeInp = $('.J-running-time').find('.time-input');
      let capacity = $timeInp.data('capacity');
      let maxPower = $timeInp.data('maxpower');
      let efficiency = $timeInp.data('efficiency');
      let acConsumption = $timeInp.data('ac_consumption');

      let value = $timeInp.val();
      if (capacity && value) {
        if (maxPower && (Number(value) > Number(maxPower))) {
          let text = `${maxPower}W`
          $('.J-running-time .running-error').find('span').text(text)
          $('.J-running-time .running-error').show()
        } else {
          let result = window.getRunningTime(Number(value), Number(capacity), Number(efficiency), Number(acConsumption));
          $('.J-running-time').find('.number').text(Number(result)?.toLocaleString(window.Shopify.locale))
          $('.J-running-time .running-error').find('span').text('')
          $('.J-running-time .running-error').hide()
        }
      } else {
        $('.J-running-time').find('.number').text(0)
        $('.J-running-time .running-error').find('span').text('')
        $('.J-running-time .running-error').hide()
      }
    });

    // 把tabs 移动出来, 放到main的下面
    function insertAfter(newNode, referenceNode) {
      const parent = referenceNode?.parentNode;
      const nextNode = referenceNode?.nextSibling;
      if (nextNode) {
        parent.insertBefore(newNode, nextNode);
      } else {
        parent.appendChild(newNode);
      }
    }
    insertAfter(document.querySelector('.tabs-header'), document.querySelector('.main-product,.section-product-main-new'));

    $('.J-tabs-point').find('li').click(function() {
      $(this).addClass('active').siblings().removeClass('active');
      let point = $(this).data('point'), top = null;

      // 兼容设置/自定义anchor
      let anchor_1 = $("[data-anchor='anchor__1']")[0] || $('#features')[0]
      let anchor_2 = $("[data-anchor='anchor__2']")[0] || $('#specs')[0]
      let anchor_3 = $("[data-anchor='anchor__3']")[0] || $('.shopify-section.faq')[0]
      let anchor_4 = $("[data-anchor='anchor__4']")[0] || $('.shopify-section.reviews')[0]
      let anchor_5 = $("[data-anchor='anchor__5']")[0] || $('.tabs-five-video')[0]

      switch (point) {
        case "features": top = anchor_1.offsetTop; break;
        case "specs": top = anchor_2.offsetTop; break;
        case "faq": top = anchor_3.offsetTop; break;
        case "reviews": top = anchor_4.offsetTop; break;
        case "video": top = anchor_5.offsetTop; break;
      }
      top && scrollToTop(top)
    });

    $('.J-header-slide').click(function() {
      if($(this).parent().siblings('.content').hasClass("animating")) return
      $(this).parent().siblings('.content').addClass("animating")
      $(this).parent().siblings('.content').slideToggle('slow', function() {
        $(this).removeClass("animating")
      })
      if ($(this).hasClass('slide-up')) {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_4.svg?v=1678936033'
        $(this).attr('src', src)
        $(this).removeClass('slide-up')
      } else {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon-_5.svg?v=1678936033'
        $(this).attr('src', src)
        $(this).addClass('slide-up')
      }
    });

    $('.J-header-item-slide').click(function() {
      $(this).parent().siblings('.item-box-content').slideToggle()
      if ($(this).hasClass('slide-up')) {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_4.svg?v=1678936033'
        $(this).attr('src', src)
        $(this).removeClass('slide-up')
      } else {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon-_5.svg?v=1678936033'
        $(this).attr('src', src)
        $(this).addClass('slide-up')
      }
    });

    // charge quickly
    $('.J-charge-quickly').find('.table-item').click(function() {
      $(this).addClass('active').siblings().removeClass('active')
      let src = $(this).data('bg-img')
      let index = $(this).index()
      $('.J-charge-quickly').find('.img-box').attr('src', src)
      $('.J-charge-quickly').find('.mob-tabs li').eq(index).addClass('active').siblings().removeClass('active')
    });
    $('.J-charge-quickly').find('.mob-tabs li').click(function() {
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      let src = $('.J-charge-quickly').find('.mob-items .table-item').eq(index).data('bg-img')
      $('.J-charge-quickly').find('.img-box').attr('src', src)
      $('.J-charge-quickly').find('.mob-items .table-item').eq(index).addClass('active').siblings().removeClass('active')
    })

    // view more
    $(".faq-box .z-button-fill-middle").click(function() {
      $(this).parent().hasClass("minimum") ? $(this).parent().removeClass("minimum") : $(this).parent().addClass("minimum")
    })

    _this.numberJump();

    // more appliance
    _this.appliance()
  }
  variantChange(variant, help, helpToChoose) {
    // get contrastInfo and specsInfo
    this.getContrastInfo(variant.id);
    this.getSpecsInfo(variant.id);
    this.getVariantManual(variant.sku, variant.id);

    // 切换变体是否要改变推荐
    if (helpToChoose.hideRecommended && document.querySelector(".product-help-choose-wrapper")) {
      try {
        window.pageInfo.template.indexOf("sg-") == -1 &&  help && (help.goodsSolarSkuId = variant.id)
      } catch (error) {
        console.error(error)
      }

      document.querySelector(".product-help-choose-wrapper") && help?.init()
    }
  }
  essential(el, res) {
    const _this = this
    el.change(function() {
      if (res.all) {
        res.all.map(item => {
          if (item.skuId.toString() === $(this).val()) {
            _this.changeSelectDom(item, res, $(this))
          }
        })
      }
    })
  }
  slideToggle(el) {
    el.find('.J-header-item-slide').click(function() {
      $(this).parent().siblings('.item-box-content').slideToggle();
      if ($(this).hasClass('slide-up')) {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_4.svg?v=1678936033';
        $(this).attr('src', src);
        $(this).removeClass('slide-up')
      } else {
        let src = 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon-_5.svg?v=1678936033';
        $(this).attr('src', src);
        $(this).addClass('slide-up')
      }
    })
  }
  downloadPdf(el) {
    el.find('.z-button-fill-middle').click(function() {
      let src = $(this).data('download-src');
      src && downloadFile(src)
    })
  }
  getVariantManual(sku, id) {

    $(".user-manual .manual-list dd").remove();
    // 如果shopify元字段有配置，则取shopify的，没有则取接口
    const _currentVariant = window.product.productVariants[id]
    const batteryInfos = _currentVariant.batteryInfos || []
    if (batteryInfos.length > 0) {
      let dd = '';
      batteryInfos.forEach(item => {
        dd += `
          <dd>
            <p class="text-sm font-500"><i class="iconfont jackery-icon-pdf"></i>${item.title}</p>
            <a href="${item.url}" target="_blank" class="z-button-fill-middle"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.page_productStrings.download}</span></a>
          </dd>
        `;
      })
      $(".user-manual .manual-list").append(dd);
      return false
    }

    let { helpToChoose } = this.config;
    // 判断是套装还是单品, 套装查询getPackagedInfo, 单品查询getGoodsInfo
    if (helpToChoose.pageType === "sg_gather") {
      getPackagedInfo({ shopify_shop_id: shopId, sku }).then((r) => {
        let dd = '';
        r.data.filter((item) => !!item.introduceBookUrlDesc).forEach((item) => {
          dd += `
          <dd>
            <p class="text-sm font-500"><i class="iconfont jackery-icon-pdf"></i>${item.title}</p>
            <a href="${item.introduceBookUrlDesc}" target="_blank" class="z-button-fill-middle"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.page_productStrings.download}</span></a>
          </dd>
        `;
        });
        $(".user-manual .manual-list").append(dd);
        // this.downloadPdf($(".user-manual .list"))
      })
    } else {
      getGoodsInfo({ shopify_shop_id: shopId, sku }).then((r) => {
        if (r.data.introduceBookUrlDesc) {
          const d_html = `
            <dd>
              <p class="text-sm font-500"><i class="iconfont jackery-icon-pdf"></i>${r.data.title}</p>
              <a href="${r.data.introduceBookUrlDesc}" target="_blank" class="z-button-fill-middle"><i class="iconfont jackery-icon-download"></i>&nbsp;<span>${window.page_productStrings.download}</span></a>
            </dd>
          `;
          $(".user-manual .manual-list").append(d_html);
          // this.downloadPdf($(".user-manual .manual-list"))
        }
      })
    }
  }
  getContrastInfo(skuId) {
    const DOM = $('.J-product-contrast')

    let params = {
      shopifyShopId: shopId,
      skuId: skuId
    }
    productContrast(params).then(res => {
      if (res.code === 200 && res.data.haveCompareInfo) {
        let html = this.creatContrastDom(res.data)
        DOM.find('.contrast-wrap').html(html)
        DOM.show()
        this.essential(DOM.find(".J-select-product"), res.data)
      } else {
        DOM.find('.contrast-wrap').empty()
        DOM.hide()
      }
    })
  }
  creatContrastDom(res) {
    let mainInfos = '', compareOneInfos = '', compareTwoInfos = ''
    res.main.compareInfos && res.main.compareInfos.map(item => {
      mainInfos += `<span>${item}</span>`
    })
    res.compareOne.compareInfos && res.compareOne.compareInfos.map(n => {
      compareOneInfos += `<span>${n}</span>`
    })
    res.compareTwo.compareInfos && res.compareTwo.compareInfos.map(v => {
      compareTwoInfos += `<span>${v}</span>`
    })
    let main = `
      <li class="contrast-product main-pdt">
        <img src="${res.main.image}" alt="">
        <div class="flex flex-col" style="flex:1;justify-content:flex-start;">
          <div class="name">${res.main.title}</div>
          <div class="param text-base ${mainInfos === '' ? 'display-none' : ''}">
            ${mainInfos}
          </div>
        </div>
      </li>
    `;
    let ids = res.compareTwo.skuId ? [res.compareOne.skuId, res.compareTwo.skuId] : [res.compareOne.skuId]
    let selectDomOne = this.creatSelectDom(res.all, res.compareOne.skuId, ids)
    let selectDomTwo = this.creatSelectDom(res.all, res.compareTwo.skuId, ids)
    let compareOne = `
      <li class="contrast-product" data-index="compareOne">
        <select class="select-product J-select-product" value="${res.compareOne.skuId}">
          ${selectDomOne}
        </select>
        <img src="${res.compareOne.image}" alt="">
        <div class="flex flex-col" style="flex:1;justify-content:space-between;">
          <div class="name">
            <a class="text-inherit" href="${window.location.origin + '/products/' + res.compareOne.handle}">${res.compareOne.title}</a>
          </div>
          <div class="param text-base ${compareOneInfos === '' ? 'display-none' : ''}">
            ${compareOneInfos}
          </div>
          <div class="more">
            <a class="z-button-fill-middle" href="${window.location.origin + '/products/' + res.compareOne.handle}" data-analytics-title="${res.compareOne.title}">
              <span>${window.page_productStrings.viewMore}</span>
              <i class="iconfont jackery-icon-arrow-right"></i>
            </a>
          </div>
        </div>
      </li>
    `;
    let compareTwo = '';
    if (res.compareTwo.gid) {
      compareTwo = `
        <li class="contrast-product" data-index="compareTwo">
          <select class="select-product J-select-product" value="${res.compareTwo.skuId}">
            ${selectDomTwo}
          </select>
          <img src="${res.compareTwo.image}" alt="">
          <div class="flex flex-col" style="flex:1;justify-content:space-between;">
            <div class="name">
              <a class="text-inherit" href="${window.location.origin + '/products/' + res.compareTwo.handle}">${res.compareTwo.title}</a>
            </div>
            <div class="param text-base ${compareTwoInfos === '' ? 'display-none' : ''}">
              ${compareTwoInfos}
            </div>
            <div class="more">
              <a class="z-button-fill-middle" href="${window.location.origin + '/products/' + res.compareTwo.handle}" data-analytics-title="${res.compareTwo.title}">
                <span>${window.page_productStrings.viewMore}</span>
                <i class="iconfont jackery-icon-arrow-right"></i>
              </a>
            </div>
          </div>
        </li>
      `
    }
    let html = main + compareOne + compareTwo
    return html
  }
  creatSelectDom(data, skuId, ids) {
    let options = ''
    if (data) {
      data.map(item => {
        options += `
          <option ${item.skuId === skuId ? 'selected' : ''} ${ids.indexOf(item.skuId) !== -1 ? 'disabled' : ''} value="${item.skuId}">${item.title}</option>
        `
      })
    }
    return options
  }
  changeSelectDom(item, res, el) {

    let infos = ''
    let index = el.parent('.contrast-product').data('index') === 'compareTwo' ? 1 : 0
    const DOM = $('.J-product-contrast')
    item.compareInfos && item.compareInfos.map(n => {
      infos += `<span>${n}</span>`
    })
    let ids = [item.skuId], otherSelectId = ''
    if (index === 1) {
      ids.push(DOM.find(".J-select-product").eq(0).attr('value'))
      otherSelectId = DOM.find(".J-select-product").eq(0).attr('value')
    } else {
      DOM.find(".J-select-product").eq(1).attr('value') ? ids.push(DOM.find(".J-select-product").eq(1).attr('value')) : ''
      otherSelectId = DOM.find(".J-select-product").eq(1).attr('value')
    }
    let selectDom = this.creatSelectDom(res.all, item.skuId, ids)
    let html = `
      <select class="select-product J-select-product" value="${item.skuId}">
        ${selectDom}
      </select>
      <img src="${item.image}" alt="">
      <div class="flex flex-col" style="flex:1;justify-content:space-between;">
        <div class="name">${item.title}</div>
        <div class="param text-base ${infos === '' ? 'display-none' : ''}">
          ${infos}
        </div>
        <div class="more">
          <a class="z-button-fill-middle" href="${window.location.origin + '/products/' + item.handle}">
            <span>${window.page_productStrings.viewMore}</span>
            <i class="iconfont jackery-icon-arrow-right"></i>
          </a>
        </div>
      </div>
    `;

    if (otherSelectId) {
      // const other_options = el.parent('.contrast-product').siblings('.contrast-product').find('.J-select-product option')
      // el.parent('.contrast-product').siblings('.contrast-product').find('.J-select-product')

      // FIX: 更新对应的option属性即可
      el.parent('.contrast-product').siblings('.contrast-product').find('.J-select-product option').each((_, item) => {
        const __r = ids.filter(i => $(item).attr("value") == i)
        if(__r.length > 0) {
          $(item).attr("disabled", "true")
        } else {
          $(item).removeAttr("disabled")
        }
      })


      // let otherSelectDom = this.creatSelectDom(res.all, otherSelectId, ids)
      // el.parent('.contrast-product').siblings('.contrast-product').find('.J-select-product').empty().html(otherSelectDom)
    }
    el.parent('.contrast-product').empty().html(html)
    this.essential(DOM.find(".J-select-product"), res)
  }
  getSpecsInfo(skuId) {
    const DOM = $('.J-specs-box')
    let params = {
      shopifyShopId: shopId,
      skuId: skuId
    }
    productBaseInfo(params).then(res => {
      let data = res.data;
      if (data) {
        let dom = this.creatSpecsDom(data)
        DOM.find('.content').html(dom)
        DOM.show()
        this.slideToggle(DOM.find('.content'))
      } else {
        DOM.find('.content').empty()
        DOM.hide()
      }
    })
  }
  creatSpecsItemDom(obj) {
    let html = ''
    for (let n in obj) {
      if (typeof(obj[n]) === 'string') {
        html += `
          <div class="specs-item">
            <span class="key">${n}${obj[n]? ':' : ''}</span>
            <span class="value">${replaceLineBreak(obj[n])}</span>
          </div>
        `
      } else {
        html += this.creatSpecsItemDom(obj[n])
      }
    }
    return html
  }
  creatSpecsDom(data) {
    let box = '';
    data.map(item => {
      if (item.baseInfos) {
        let row = '';
        for (let i in item.baseInfos) {
          let col = '';
          if (item.baseInfos[i]) {
            let obj = item.baseInfos[i]
            if (typeof(obj) === 'string') {
              col += `
              <div class="specs-item">
                <span class="key">${obj}</span>
              </div>
              `
            } else {
              col += this.creatSpecsItemDom(obj)
              // for (let n in obj) {
              //   if (typeof(obj[n]) === 'string') {
              //     col += `
              //     <div class="specs-item">
              //       <span class="key">${n}${obj[n]? ':' : ''}</span>
              //       <span class="value">${obj[n]}</span>
              //     </div>
              //     `
              //   } else {
              //     for (let v in obj[n]) {
              //       let child = obj[n]
              //       col += `
              //         <div class="specs-item">
              //           <span class="key">${v}${child[v] ? ':' : ''}</span>
              //           <span class="value">${child[v]}</span>
              //         </div>
              //       `
              //     }
              //   }
              // }
            }
          }
          row += `
            <div class="specs-row">
              <div class="title">${i}</div>
              <div class="specs-wrap">
                ${col}
              </div>
            </div>
          `
        }
        box += `
          <div class="item-box">
            <div class="header">
              <span>${item.title}</span>
              <img class="J-header-item-slide slide-up" src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon-_5.svg?v=1678936033" alt="">
            </div>
            <div class="item-box-content">${row}</div>
          </div>
        `
      }
    })
    return box
  }

  numberJump() {
    let lock = [];

    window.addEventListener('scroll', function() {
      let windowHeight = document.documentElement.clientHeight;
      let scrollBarTop = document.documentElement.scrollTop || document.body.scrollTop;
      let target = document.querySelectorAll(".numberJump");

      target.forEach((item, index) => {
        let targetCountUp = item.querySelector(".countUp");
        if (!lock[index] && item.offsetTop < (windowHeight + scrollBarTop - windowHeight / 2)) {
          lock[index] = true;
          countUp(item.querySelector(".countUp span"), +targetCountUp.dataset.countStart, +targetCountUp.dataset.countEnd)
        }
      })
    })
  }

  appliance() {
    const wt = $(".appliance-container .wattage dd"), eq = $(".appliance-container .equipment");
    const equipment = {
      "0Wh~100W": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/Light.png?v=1681092312",
        data: ["Light", "Camera", "Bluetooth speaker", "Phone", "CPAP", "Electric blanket", "Laptop", "Projection"]
      },
      "100Wh~300Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/Desktop.png?v=1680867008",
        data: ["Desktop", "Electric nursing bed", "Heated throw", "Blender", "Fish tank heating rod"]
      },
      "300Wh~500Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/Space_Heater.png?v=1681113447",
        data: ["Space Heater", "Electric wheelchair", "Ice maker", "Hair curling iron", "Oxygen concentrator"]
      },
      "500Wh~700Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_Coffee_Maker.svg?v=1678851033",
        data: ["Home refrigerator", "Coffee Maker", "Car wash", "Toaster", "Ice shaver", "Microwave", "Blower"]
      },
      "700Wh~1000Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/Electric_rice_cooker.png?v=1680867008",
        data: ["Electric rice cooker", "Kettle", "Angle grinder", "Electric grill", "High branch saws/pruning saws"]
      },
      "1000Wh~1500Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_Juicer.svg?v=1678851033",
        data: ["Juicer", "Electric pressure cooker", "Coffee maker", "Portable Air Conditioner", "Multifunctional cooking pot"]
      },
      "1500Wh~3000Wh": {
        img: "https://cdn.shopify.com/s/files/1/0550/0524/9633/files/icon_Microwave.svg?v=1678851033",
        data: ["Electric kettle", "Electric Oven", "Outdoor electric grill", "Branch crusher", "Induction cooker"]
      }
    };
    wt.click(function() {
      wt.removeClass("active");
      $(this).addClass("active");
      eq.empty();

      let device = $(this).data("wattage");
      let device_info = equipment[device];
      let image = `<div class="image"><img src="${device_info.img}" alt="${device}" /><p class="text-xs">${device}</p></div>`;
      let span = "";
      device_info.data.forEach((item) => {
        span += `<span>${item}</span>`
      })
      eq.html(`${image}<figcaption>${span}</figcaption>`)
    })

    // default get first
    wt.eq(0).click()
  }
}

window.ProductContrast = ProductContrastInfo;


window.$(document).ready(function(){
  if ($(".card-swiper-container .swiper-slide").length > 1) {
    new BlogCardSwiper({
      swiperContainer: '.card-swiper-container', el: '.card-swiper'
    })
  }

  if ($(".user-guide-swiper .swiper-slide").length > 1) {
    new BlogCardSwiper({
      swiperContainer: '.user-guide-swiper',
      el: '.user-guide-swiper'
    })
  }
})
